export function isNullOrUndefined(value) {
  return value === null || value === undefined
}

export function isBoolean(value) {
  return typeof value === 'boolean'
}
